__turbopack_context__.v({
  "card": "ParagraphWhyUs-module__k4xvua__card",
  "desc": "ParagraphWhyUs-module__k4xvua__desc",
  "eyebrow": "ParagraphWhyUs-module__k4xvua__eyebrow",
  "grid": "ParagraphWhyUs-module__k4xvua__grid",
  "header": "ParagraphWhyUs-module__k4xvua__header",
  "iconBox": "ParagraphWhyUs-module__k4xvua__iconBox",
  "lead": "ParagraphWhyUs-module__k4xvua__lead",
  "name": "ParagraphWhyUs-module__k4xvua__name",
  "section": "ParagraphWhyUs-module__k4xvua__section",
  "title": "ParagraphWhyUs-module__k4xvua__title",
});
